/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Publish_Confirm_HintInputs */

const vi_einvoice_publish_confirm_hint = /** @type {(inputs: Einvoice_Publish_Confirm_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hóa đơn sẽ được phát hành chính thức trên MISA theo đúng bản nháp đang xem. Sau khi phát hành, không thể thu hồi bằng thao tác hủy đơn. Chỉ xác nhận khi người mua, hàng hóa và tiền thuế đã đúng.`)
};

/**

* @param {Einvoice_Publish_Confirm_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_publish_confirm_hint = /** @type {((inputs?: Einvoice_Publish_Confirm_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Publish_Confirm_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_publish_confirm_hint(inputs)
});